module.exports = __webpack_public_path__ + "static/media/1pic.1bb92299.png";